import { Injectable } from '@angular/core';
import type { CardDescriptorInterface } from '@zaoblako/shared/common/dtos/card/card-descriptor.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { HelpdeskTaskFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/helpdesk-task-find.dto';
import type { HelpdeskTaskPersonalAccountPageInterface } from '@zaoblako/shared/modules/helpdesk/dto/task/helpdesk-task-personal-account-page.dto';
import type { HelpdeskTaskStatusFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/helpdesk-task-status-find.dto';
import type { HelpdeskTaskTypeFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/task-type/helpdesk-task-type-find.dto';
import type { HelpdeskTaskPersonalAccountQueryInterface } from '@zaoblako/shared/modules/helpdesk/dto/task/helpdesk-task-personal-account-query.dto';
import type { CommentaryFileFindInterface } from '@zaoblako/shared/modules/storage/dtos/commentary-file/commentary-file-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersonalAccountHdTaskService extends BaseService {
  protected baseUrl = '/personal-account/helpdesk/task';
  protected numberPrefix = 'HD';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public getCardDescriptor(taskId?: number): Observable<CardDescriptorInterface> {
    return this.http.get<CardDescriptorInterface>(`${this.baseUrl}/card-descriptor`, {
      params: taskId ? { taskId } : {}
    });
  }

  public findWithPagination(
    queryParams: HelpdeskTaskPersonalAccountQueryInterface
  ): Observable<HelpdeskTaskPersonalAccountPageInterface> {
    return this.http.get<HelpdeskTaskPersonalAccountPageInterface>(`${this.baseUrl}/items`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getFiles(taskId: number): Observable<CommentaryFileFindInterface[]> {
    return this.http.get<CommentaryFileFindInterface[]>(`${this.baseUrl}/${taskId}/files`);
  }

  public getTaskTypes(): Observable<HelpdeskTaskTypeFindInterface[]> {
    return this.http.get<HelpdeskTaskTypeFindInterface[]>('/personal-account/helpdesk/task-type');
  }

  public getTaskStatuses(): Observable<HelpdeskTaskStatusFindInterface[]> {
    return this.http.get<HelpdeskTaskStatusFindInterface[]>('/personal-account/helpdesk/task-status');
  }

  public toggleFavorite(taskId: number): Observable<HelpdeskTaskFindInterface> {
    return this.http.post<HelpdeskTaskFindInterface>(`${this.baseUrl}/${taskId}/toggle-favorite`, {});
  }
}
